/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/scope */
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
const ES3Update = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [errortotal1, seterrortotal1] = useState(false)
    const [ncoError, setNcoError] = useState(false)
    const [formData, setFormData] = useState({
        Es3detailsId: Number(props.es3detailsId),
        _8DigitNco20152 : "",
        Total3 : 0,
        Women4 : 0,
        Transgender5 : 0,
        Sc6 : 0,
        St7 : 0,
        Obc8 : 0,
        Pwd9 : 0,
        Tota10 : 0,
        Women11 : 0,
        Transgender12 : 0,
        Sc13 : 0,
        St14 : 0,
        Obc15 : 0,
        Pwd16 : 0,
        Total17 : 0,
        Women18 : 0,
        Transgender19 : 0,
        Sc20 : 0,
        St21 : 0,
        Obc22 : 0,
        Pwd23 : 0,
        Total24 : 0,
        Women25 : 0,
        Transgender26 : 0,
        Sc27 : 0,
        St28 : 0,
        Obc29 : 0,
        Pwd30 : 0,
        Total31 : 0,
        Women32 : 0,
        Transgender33 : 0,
        Sc34 : 0,
        St35 : 0,
        Obc36 : 0,
        Pwd37 : 0,
    });


    const getdata = async () => {
        const sendData = {
            Es3detailsId: Number(props.es3detailsId),

        }
        ////console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK+'api/Main/GetES3Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                data => {
                    if (data && data.length > 0) {
                        const maindata = data[0]
                        ////console.log(maindata)
                        setFormData({
                            _8DigitNco20152: sanitizeValue(maindata._8DigitNco20152),
                            Total3: sanitizeValue(maindata.total3),
                            Women4: sanitizeValue(maindata.women4),
                            Transgender5: sanitizeValue(maindata.transgender5),
                            Sc6: sanitizeValue(maindata.sc6),
                            St7: sanitizeValue(maindata.st7),
                            Obc8: sanitizeValue(maindata.obc8),
                            Pwd9: sanitizeValue(maindata.pwd9),
                            Tota10: sanitizeValue(maindata.tota10),
                            Women11: sanitizeValue(maindata.women11),
                            Transgender12: sanitizeValue(maindata.transgender12),
                            Sc13: sanitizeValue(maindata.sc13),
                            St14: sanitizeValue(maindata.st14),
                            Obc15: sanitizeValue(maindata.obc15),
                            Pwd16: sanitizeValue(maindata.pwd16),
                            Total17: sanitizeValue(maindata.total17),
                            Women18: sanitizeValue(maindata.women18),
                            Transgender19: sanitizeValue(maindata.transgender19),
                            Sc20: sanitizeValue(maindata.sc20),
                            St21: sanitizeValue(maindata.st21),
                            Obc22: sanitizeValue(maindata.obc22),
                            Pwd23: sanitizeValue(maindata.pwd23),
                            Total24: sanitizeValue(maindata.total24),
                            Women25: sanitizeValue(maindata.women25),
                            Transgender26: sanitizeValue(maindata.transgender26),
                            Sc27: sanitizeValue(maindata.sc27),
                            St28: sanitizeValue(maindata.st28),
                            Obc29: sanitizeValue(maindata.obc29),
                            Pwd30: sanitizeValue(maindata.pwd30),
                            Total31: sanitizeValue(maindata.total31),
                            Women32: sanitizeValue(maindata.women32),
                            Transgender33: sanitizeValue(maindata.transgender33),
                            Sc34: sanitizeValue(maindata.sc34),
                            St35: sanitizeValue(maindata.st35),
                            Obc36: sanitizeValue(maindata.obc36),
                            Pwd37: sanitizeValue(maindata.pwd37),
                            Es3detailsId: Number(props.es3detailsId),
                        });
                    }
                    setload(false)
                })
            .catch(error => {
                console.error('Error fetching data:', error);
                setload(false);
            })


    };
    
    // Helper function to clean undefined values from database
    const sanitizeValue = (value) => {
        if (value === "undefined" || value === undefined || value === null) return '';
        return value;
    };

    // Helper function to prepare form data for API - converts empty numeric fields to 0
    const prepareFormDataForAPI = (data) => {
        const numericFields = [
            'Total3', 'Women4', 'Transgender5', 'Sc6', 'St7', 'Obc8', 'Pwd9',
            'Tota10', 'Women11', 'Transgender12', 'Sc13', 'St14', 'Obc15', 'Pwd16',
            'Total17', 'Women18', 'Transgender19', 'Sc20', 'St21', 'Obc22', 'Pwd23',
            'Total24', 'Women25', 'Transgender26', 'Sc27', 'St28', 'Obc29', 'Pwd30',
            'Total31', 'Women32', 'Transgender33', 'Sc34', 'St35', 'Obc36', 'Pwd37'
        ];
        
        const preparedData = { ...data };
        numericFields.forEach(field => {
            const value = preparedData[field];
            // Convert to number, or 0 if empty
            if (value === '' || value === undefined || value === null) {
                preparedData[field] = 0;
            } else {
                preparedData[field] = Number(value);
            }
        });
        return preparedData;
    };
    
    const onInputChange = async (e) => {
        //console.log(Number(e.target.value))
        e.target.value < 0 ? e.target.value = null : String(e.target.value)
        setFormData({ ...formData, [e.target.name]: String(e.target.value) });
        const sendData = prepareFormDataForAPI({ ...formData, [e.target.name]: String(e.target.value) })
        console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/UpdateDetailsES3', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                maindata => {
                    if (maindata) {
                        setFormData({
                            _8DigitNco20152: maindata._8DigitNco20152,
                            Total3: maindata.total3,
                            Women4: maindata.women4,
                            Transgender5: maindata.transgender5,
                            Sc6: maindata.sc6,
                            St7: maindata.st7,
                            Obc8: maindata.obc8,
                            Pwd9: maindata.pwd9,
                            Tota10: maindata.tota10,
                            Women11: maindata.women11,
                            Transgender12: maindata.transgender12,
                            Sc13: maindata.sc13,
                            St14: maindata.st14,
                            Obc15: maindata.obc15,
                            Pwd16: maindata.pwd16,
                            Total17: maindata.total17,
                            Women18: maindata.women18,
                            Transgender19: maindata.transgender19,
                            Sc20: maindata.sc20,
                            St21: maindata.st21,
                            Obc22: maindata.obc22,
                            Pwd23: maindata.pwd23,
                            Total24: maindata.total24,
                            Women25: maindata.women25,
                            Transgender26: maindata.transgender26,
                            Sc27: maindata.sc27,
                            St28: maindata.st28,
                            Obc29: maindata.obc29,
                            Pwd30: maindata.pwd30,
                            Total31: maindata.total31,
                            Women32: maindata.women32,
                            Transgender33: maindata.transgender33,
                            Sc34: maindata.sc34,
                            St35: maindata.st35,
                            Obc36: maindata.obc36,
                            Pwd37: maindata.pwd37,
                            Es3detailsId: Number(props.es3detailsId),
                           
                        });
                    }
                    setload(false);
                    // Trigger total recalculation AFTER data is fully updated
                    props.setGTotal(props.GTotal + 1);
                })
            .catch(error => {
                console.error('Error updating data:', error);
                setload(false);
            })
    };

    const handleNcoChange = async (e, showAlert = true) => {
        let value = e.target.value.replace(/[^0-9Xx]/g, '');
        
        if (value.length > 8) {
            value = value.slice(0, 8);
            e.target.value = value;
            if (showAlert) {
                const Swal = (await import('sweetalert2')).default;
                Swal.fire({
                    icon: 'warning',
                    title: 'Invalid Input',
                    text: 'Please enter a valid 8 character NCO code',
                    confirmButtonText: 'OK'
                });
            }
            return;
        }

        if (value.length === 8) {
            setNcoError(false);
        }

        setFormData({ ...formData, _8DigitNco20152: value });
        const sendData = prepareFormDataForAPI({
            ...formData,
            _8DigitNco20152: value,
        });

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/UpdateDetailsES3', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                maindata => {
                    if (maindata) {
                        setFormData({
                            _8DigitNco20152: maindata._8DigitNco20152,
                            Total3: maindata.total3,
                            Women4: maindata.women4,
                            Transgender5: maindata.transgender5,
                            Sc6: maindata.sc6,
                            St7: maindata.st7,
                            Obc8: maindata.obc8,
                            Pwd9: maindata.pwd9,
                            Tota10: maindata.tota10,
                            Women11: maindata.women11,
                            Transgender12: maindata.transgender12,
                            Sc13: maindata.sc13,
                            St14: maindata.st14,
                            Obc15: maindata.obc15,
                            Pwd16: maindata.pwd16,
                            Total17: maindata.total17,
                            Women18: maindata.women18,
                            Transgender19: maindata.transgender19,
                            Sc20: maindata.sc20,
                            St21: maindata.st21,
                            Obc22: maindata.obc22,
                            Pwd23: maindata.pwd23,
                            Total24: maindata.total24,
                            Women25: maindata.women25,
                            Transgender26: maindata.transgender26,
                            Sc27: maindata.sc27,
                            St28: maindata.st28,
                            Obc29: maindata.obc29,
                            Pwd30: maindata.pwd30,
                            Total31: maindata.total31,
                            Women32: maindata.women32,
                            Transgender33: maindata.transgender33,
                            Sc34: maindata.sc34,
                            St35: maindata.st35,
                            Obc36: maindata.obc36,
                            Pwd37: maindata.pwd37,
                            Es3detailsId: Number(props.es3detailsId),
                        });
                    }
                    setload(false);
                    // Trigger total recalculation AFTER data is fully updated
                    props.setGTotal(props.GTotal + 1);
                })
            .catch(error => {
                console.error('Error updating data:', error);
                setload(false);
            })
    };

    const onInputChange1 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = prepareFormDataForAPI({
            ...formData, [e.target.name]: Number(e.target.value)
        })
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES3total1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                maindata => {
                    if (maindata === "Error") {
                       
                        setFormData({ ...formData, [e.target.name]: Number(formData[e.target.name]) });
                        Swal.fire({
                            title: 'Total Should be Greater from all categories',
                            text:'Total of No of applicants on the Live Register at the end of the month in respect of',
                            icon: 'error',

                        })
                        e.target.value = formData[e.target.name]
                      
             
                      
                    } else if (maindata) {

         
                        setFormData({
                            _8DigitNco20152: maindata._8DigitNco20152,
                            Total3: maindata.total3,
                            Women4: maindata.women4,
                            Transgender5: maindata.transgender5,
                            Sc6: maindata.sc6,
                            St7: maindata.st7,
                            Obc8: maindata.obc8,
                            Pwd9: maindata.pwd9,
                            Tota10: maindata.tota10,
                            Women11: maindata.women11,
                            Transgender12: maindata.transgender12,
                            Sc13: maindata.sc13,
                            St14: maindata.st14,
                            Obc15: maindata.obc15,
                            Pwd16: maindata.pwd16,
                            Total17: maindata.total17,
                            Women18: maindata.women18,
                            Transgender19: maindata.transgender19,
                            Sc20: maindata.sc20,
                            St21: maindata.st21,
                            Obc22: maindata.obc22,
                            Pwd23: maindata.pwd23,
                            Total24: maindata.total24,
                            Women25: maindata.women25,
                            Transgender26: maindata.transgender26,
                            Sc27: maindata.sc27,
                            St28: maindata.st28,
                            Obc29: maindata.obc29,
                            Pwd30: maindata.pwd30,
                            Total31: maindata.total31,
                            Women32: maindata.women32,
                            Transgender33: maindata.transgender33,
                            Sc34: maindata.sc34,
                            St35: maindata.st35,
                            Obc36: maindata.obc36,
                            Pwd37: maindata.pwd37,
                            Es3detailsId: Number(props.es3detailsId),

                        });
                    }
                    setload(false);
                    // Trigger total recalculation AFTER data is fully updated
                    props.setGTotal(props.GTotal + 1);
                })
            .catch(error => {
                console.error('Error updating data:', error);
                setload(false);
            })
    };

    const onInputChange2 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = prepareFormDataForAPI({
            ...formData, [e.target.name]: Number(e.target.value)
        })
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES3total2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                maindata => {
                    if (maindata === "Error") {

                        setFormData({ ...formData, [e.target.name]: Number(formData[e.target.name]) });
                        Swal.fire({
                            title: 'Total Should be Greater from all categories',
                            text: 'Total of Notified upto the current month',
                            icon: 'error',

                        })
                        e.target.value = formData[e.target.name]



                    } else if (maindata) {


                        setFormData({
                            _8DigitNco20152: maindata._8DigitNco20152,
                            Total3: maindata.total3,
                            Women4: maindata.women4,
                            Transgender5: maindata.transgender5,
                            Sc6: maindata.sc6,
                            St7: maindata.st7,
                            Obc8: maindata.obc8,
                            Pwd9: maindata.pwd9,
                            Tota10: maindata.tota10,
                            Women11: maindata.women11,
                            Transgender12: maindata.transgender12,
                            Sc13: maindata.sc13,
                            St14: maindata.st14,
                            Obc15: maindata.obc15,
                            Pwd16: maindata.pwd16,
                            Total17: maindata.total17,
                            Women18: maindata.women18,
                            Transgender19: maindata.transgender19,
                            Sc20: maindata.sc20,
                            St21: maindata.st21,
                            Obc22: maindata.obc22,
                            Pwd23: maindata.pwd23,
                            Total24: maindata.total24,
                            Women25: maindata.women25,
                            Transgender26: maindata.transgender26,
                            Sc27: maindata.sc27,
                            St28: maindata.st28,
                            Obc29: maindata.obc29,
                            Pwd30: maindata.pwd30,
                            Total31: maindata.total31,
                            Women32: maindata.women32,
                            Transgender33: maindata.transgender33,
                            Sc34: maindata.sc34,
                            St35: maindata.st35,
                            Obc36: maindata.obc36,
                            Pwd37: maindata.pwd37,
                            Es3detailsId: Number(props.es3detailsId),

                        });
                    }
                    setload(false);
                    // Trigger total recalculation AFTER data is fully updated
                    props.setGTotal(props.GTotal + 1);
                })
            .catch(error => {
                console.error('Error updating data:', error);
                setload(false);
            })
    };

    const onInputChange3 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = prepareFormDataForAPI({
            ...formData, [e.target.name]: Number(e.target.value)
        })
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES3total3', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                maindata => {
                    if (maindata === "Error") {

                        setFormData({ ...formData, [e.target.name]: Number(formData[e.target.name]) });
                        Swal.fire({
                            title: 'Total Should be Greater from all categories',
                            text: 'Total of Filled upto the current month',
                            icon: 'error',

                        })
                        e.target.value = formData[e.target.name]



                    } else if (maindata) {


                        setFormData({
                            _8DigitNco20152: maindata._8DigitNco20152,
                            Total3: maindata.total3,
                            Women4: maindata.women4,
                            Transgender5: maindata.transgender5,
                            Sc6: maindata.sc6,
                            St7: maindata.st7,
                            Obc8: maindata.obc8,
                            Pwd9: maindata.pwd9,
                            Tota10: maindata.tota10,
                            Women11: maindata.women11,
                            Transgender12: maindata.transgender12,
                            Sc13: maindata.sc13,
                            St14: maindata.st14,
                            Obc15: maindata.obc15,
                            Pwd16: maindata.pwd16,
                            Total17: maindata.total17,
                            Women18: maindata.women18,
                            Transgender19: maindata.transgender19,
                            Sc20: maindata.sc20,
                            St21: maindata.st21,
                            Obc22: maindata.obc22,
                            Pwd23: maindata.pwd23,
                            Total24: maindata.total24,
                            Women25: maindata.women25,
                            Transgender26: maindata.transgender26,
                            Sc27: maindata.sc27,
                            St28: maindata.st28,
                            Obc29: maindata.obc29,
                            Pwd30: maindata.pwd30,
                            Total31: maindata.total31,
                            Women32: maindata.women32,
                            Transgender33: maindata.transgender33,
                            Sc34: maindata.sc34,
                            St35: maindata.st35,
                            Obc36: maindata.obc36,
                            Pwd37: maindata.pwd37,
                            Es3detailsId: Number(props.es3detailsId),

                        });
                    }
                    setload(false);
                    // Trigger total recalculation AFTER data is fully updated
                    props.setGTotal(props.GTotal + 1);
                })
            .catch(error => {
                console.error('Error updating data:', error);
                setload(false);
            })
    };

    const onInputChange4 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = prepareFormDataForAPI({
            ...formData, [e.target.name]: Number(e.target.value)
        })
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES3total4', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    if (maindata === "Error") {

                        setFormData({ ...formData, [e.target.name]: Number(formData[e.target.name]) });
                        Swal.fire({
                            title: 'Total Should be Greater from all categories',
                            text: 'Total of Cancelled upto the current month',
                            icon: 'error',

                        })
                        e.target.value = formData[e.target.name]



                    } else {


                        setFormData({
                            _8DigitNco20152: maindata._8DigitNco20152,
                            Total3: maindata.total3,
                            Women4: maindata.women4,
                            Transgender5: maindata.transgender5,
                            Sc6: maindata.sc6,
                            St7: maindata.st7,
                            Obc8: maindata.obc8,
                            Pwd9: maindata.pwd9,
                            Tota10: maindata.tota10,
                            Women11: maindata.women11,
                            Transgender12: maindata.transgender12,
                            Sc13: maindata.sc13,
                            St14: maindata.st14,
                            Obc15: maindata.obc15,
                            Pwd16: maindata.pwd16,
                            Total17: maindata.total17,
                            Women18: maindata.women18,
                            Transgender19: maindata.transgender19,
                            Sc20: maindata.sc20,
                            St21: maindata.st21,
                            Obc22: maindata.obc22,
                            Pwd23: maindata.pwd23,
                            Total24: maindata.total24,
                            Women25: maindata.women25,
                            Transgender26: maindata.transgender26,
                            Sc27: maindata.sc27,
                            St28: maindata.st28,
                            Obc29: maindata.obc29,
                            Pwd30: maindata.pwd30,
                            Total31: maindata.total31,
                            Women32: maindata.women32,
                            Transgender33: maindata.transgender33,
                            Sc34: maindata.sc34,
                            St35: maindata.st35,
                            Obc36: maindata.obc36,
                            Pwd37: maindata.pwd37,
                            Es3detailsId: Number(props.es3detailsId),

                        });
                    }
                    setload(false);
                    // Trigger total recalculation AFTER data is fully updated
                    props.setGTotal(props.GTotal + 1);
                })
    };

    const onInputChange5 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = prepareFormDataForAPI({
            ...formData, [e.target.name]: Number(e.target.value)
        })
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES3total5', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    if (maindata === "Error") {

                        setFormData({ ...formData, [e.target.name]: Number(formData[e.target.name]) });
                        Swal.fire({
                            title: 'Total Should be Greater from all categories',
                            text: 'Total of Outstanding upto the current month',
                            icon: 'error',

                        })
                        e.target.value = formData[e.target.name]



                    } else {


                        setFormData({
                            _8DigitNco20152: maindata._8DigitNco20152,
                            Total3: maindata.total3,
                            Women4: maindata.women4,
                            Transgender5: maindata.transgender5,
                            Sc6: maindata.sc6,
                            St7: maindata.st7,
                            Obc8: maindata.obc8,
                            Pwd9: maindata.pwd9,
                            Tota10: maindata.tota10,
                            Women11: maindata.women11,
                            Transgender12: maindata.transgender12,
                            Sc13: maindata.sc13,
                            St14: maindata.st14,
                            Obc15: maindata.obc15,
                            Pwd16: maindata.pwd16,
                            Total17: maindata.total17,
                            Women18: maindata.women18,
                            Transgender19: maindata.transgender19,
                            Sc20: maindata.sc20,
                            St21: maindata.st21,
                            Obc22: maindata.obc22,
                            Pwd23: maindata.pwd23,
                            Total24: maindata.total24,
                            Women25: maindata.women25,
                            Transgender26: maindata.transgender26,
                            Sc27: maindata.sc27,
                            St28: maindata.st28,
                            Obc29: maindata.obc29,
                            Pwd30: maindata.pwd30,
                            Total31: maindata.total31,
                            Women32: maindata.women32,
                            Transgender33: maindata.transgender33,
                            Sc34: maindata.sc34,
                            St35: maindata.st35,
                            Obc36: maindata.obc36,
                            Pwd37: maindata.pwd37,
                            Es3detailsId: Number(props.es3detailsId),

                        });
                    }
                    setload(false);
                    // Trigger total recalculation AFTER data is fully updated
                    props.setGTotal(props.GTotal + 1);
                })
    };

    

    useEffect(() => {
        getdata()

    }, [props.Change])

    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };
   

    return (
        load ? null:
        <tr scope="row"  >

            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.value} 

            </td>

          
                {/*<td style={{ textAlign: 'center', border: '1px solid black', padding: 10}} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="_8DigitNco20152"
                       className="form-control" maxLength="8" onKeyPress={inputHandler}
                        name="_8DigitNco20152"
                        style={{ textAlign: 'center' }}
                        onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-'|| evt.key === '.') && evt.preventDefault()}
                        defaultValue={formData._8DigitNco20152}
                    /> : formData._8DigitNco20152}

                </td>*/}

                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="text"
                        inputMode="text"
                        pattern="[0-9Xx]*"
                        id="_8DigitNco20152"
                        className="form-control"
                        name="_8DigitNco20152"
                        style={{ textAlign: 'center', borderColor: ncoError ? 'red' : '', borderWidth: ncoError ? '2px' : '' }}
                        onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null}
                        onBlur={async (e) => {
                            const value = e.target.value.replace(/[^0-9Xx]/g, '');
                            if (value.length > 0 && value.length < 8) {
                                setNcoError(true);
                                const Swal = (await import('sweetalert2')).default;
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Invalid Input',
                                    text: 'Please enter a valid 8 character NCO code',
                                    confirmButtonText: 'OK'
                                });
                            } else if (e.target.value == '') {
                                e.target.value = 0;
                                setNcoError(false);
                            } else if (value.length === 8) {
                                setNcoError(false);
                            }
                        }}
                        onChange={handleNcoChange}
                        onPaste={(e) => {
                            e.preventDefault();
                            const pasted = e.clipboardData.getData('Text');
                            e.target.value = pasted;
                            handleNcoChange(e, true);
                        }}
                        onKeyDown={(evt) => {
                            if (!/[0-9Xx]/.test(evt.key) && evt.key !== 'Backspace' && evt.key !== 'Delete' && evt.key !== 'ArrowLeft' && evt.key !== 'ArrowRight' && evt.key !== 'Tab') {
                                evt.preventDefault();
                            }
                        }}
                        defaultValue={formData._8DigitNco20152}
                    /> : formData._8DigitNco20152}

                </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Total3"
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Total3"
                        style={errortotal1 ? { textAlign: 'center', color: 'red' } : { textAlign: 'center' }}
                        onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}                        defaultValue={formData.Total3}
                    /> : formData.Total3}

            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10}} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Women4"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Women4"
                        style={{ textAlign: 'center' }}
                       onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Women4}
                    /> : formData.Women4}


            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Transgender5"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Transgender5"
                        style={{ textAlign: 'center' }}
                       onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Transgender5}
                    /> : formData.Transgender5}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Sc6"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Sc6"
                        style={{ textAlign: 'center' }}
                       onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Sc6}
                    /> : formData.Sc6}

            </td>
           
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="St7"
                        className="form-control" maxLength="7"
                        onKeyPress={inputHandler}
                        name="St7"
                        style={{ textAlign: 'center' }}
                       onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.St7}
                    /> : formData.St7}

            </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Obc8"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Obc8"
                        style={{ textAlign: 'center' }}
                       onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Obc8}
                    /> : formData.Obc8}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Pwd9"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Pwd9"
                        style={{ textAlign: 'center' }}
                       onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Pwd9}
                    /> : formData.Pwd9}

            </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Tota10"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Tota10"
                        style={{ textAlign: 'center' }}
                        onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Tota10}
                    /> : formData.Tota10}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Women11"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Women11"
                        style={{ textAlign: 'center' }}
                       onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Women11}
                    /> : formData.Women11}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Transgender12"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Transgender12"
                        style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Transgender12}
                    /> : formData.Transgender12}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Sc13"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Sc13"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Sc13}
                    /> : formData.Sc13}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="St14"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="St14"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.St14}
                    /> : formData.St14}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Obc15"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Obc15"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Obc15}
                    /> : formData.Obc15}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Pwd16"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Pwd16"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Pwd16}
                    /> : formData.Pwd16}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Total17"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Total17"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Total17}
                    /> : formData.Total17}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Women18"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Women18"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Women18}
                    /> : formData.Women18}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Transgender19"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Transgender19"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Transgender19}
                    /> : formData.Transgender19}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Sc20"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Sc20"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Sc20}
                    /> : formData.Sc20}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="St21"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="St21"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.St21}
                    /> : formData.St21}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Obc22"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Obc22"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Obc22}
                    /> : formData.Obc22}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Pwd23"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Pwd23"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Pwd23}
                    /> : formData.Pwd23}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Total24"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Total24"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Total24}
                    /> : formData.Total24}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Women25"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Women25"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Women25}
                    /> : formData.Women25}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Transgender26"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Transgender26"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Transgender26}
                    /> : formData.Transgender26}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Sc27"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Sc27"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Sc27}
                    /> : formData.Sc27}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="St28"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="St28"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.St28}
                    /> : formData.St28}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Obc29"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Obc29"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Obc29}
                    /> : formData.Obc29}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Pwd30"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Pwd30"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Pwd30}
                    /> : formData.Pwd30}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Total31"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Total31"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Total31}
                    /> : formData.Total31}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Women32"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Women32"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Women32}
                    /> : formData.Women32}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Transgender33"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Transgender33"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Transgender33}
                    /> : formData.Transgender33}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        id="Sc34"
                        min="0"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Sc34"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Sc34}
                    /> : formData.Sc34}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="St35"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="St35"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.St35}
                    /> : formData.St35}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Obc36"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Obc36"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Obc36}
                    /> : formData.Obc36}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Pwd37"
                       className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Pwd37"
                       style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Pwd37}
                    /> : formData.Pwd37}

                </td>
                
        </tr>
    );
};

export default ES3Update;
